<script>
    import { user } from "../../stores";

    import { exportIcon } from "../../Utils/utilConstants.svelte";

    import {
        exportContentCSV,
        isFunctionEmpty,
        isObjectEmpty,
    } from "../../Utils/utilFunctions.svelte";

    import { LoadingModal } from "./index.svelte";

    export let csvConfig = {};
    /*
        data: [],
        columns: [],
        allDataApi: () => {},
        fileName: "",
        containerClass: "",
    */

    $: isUserAdmin = $user.role == 100;

    let isExportingCsvFile = false,
        exportData = [];

    const handleExportCurrentPage = async () => {
        isExportingCsvFile = true;

        exportData = _mapExportData(csvConfig.data);

        await exportContentCSV(exportData, csvConfig.fileName ?? "");

        isExportingCsvFile = false;
    };

    const handleExportAll = async () => {
        if (!csvConfig.allDataApi || isFunctionEmpty(csvConfig.allDataApi))
            return;

        isExportingCsvFile = true;

        const { results } = await csvConfig.allDataApi();

        exportData = _mapExportData(results);

        await exportContentCSV(exportData, csvConfig.fileName ?? "");

        isExportingCsvFile = false;
    };

    // HELPER FUNCTIONS
    const _mapExportData = (data = []) => {
        const exportColumns = csvConfig.columns.filter(
            (col) => !col.csvExportHidden,
        );

        return data.map((d) =>
            exportColumns.reduce((res, col) => {
                const key = col.title;
                const value = col.hasOwnProperty("csvContent")
                    ? col.csvContent(d)
                    : col.hasOwnProperty("renderValue")
                      ? col.renderValue(d)
                      : col.hasOwnProperty("value")
                        ? col.value(d)
                        : (d[col.key] ?? "-");

                res[key] = value;
                return res;
            }, {}),
        );
    };
</script>

<!-- {#if isUserAdmin && !isObjectEmpty(csvConfig) && csvConfig.data?.length} -->
{#if !isObjectEmpty(csvConfig) && csvConfig.data?.length}
    <div
        class="dropdown dropdown-hover dropdown-top dropdown-end bg-zinc-200 pb-1 {csvConfig.containerClass ??
            ''}"
    >
        <div
            tabindex="0"
            role="button"
            class="flex gap-x-1 items-center cursor-default w-48 h-4 p-2 text-gray-600 text-sm"
        >
            <i class={exportIcon} />
            <p class="pt-1">Export</p>
        </div>
        <ul
            tabindex="0"
            class="dropdown-content menu border-2 border-t-zinc-300 border-x-zinc-300 w-48 rounded-t-lg overflow-hidden"
        >
            <div
                class="flex gap-x-1 items-center justify-start pl-4 cursor-pointer w-48 h-12 p-2 cursor-pointer text-[#6f726c] bg-zinc-200 hover:bg-zinc-300"
                on:click|preventDefault={handleExportCurrentPage}
            >
                <i class={exportIcon} />
                <p class="pt-1">Export This Page</p>
            </div>
            <div
                class="flex gap-x-1 items-center justify-start pl-4 cursor-pointer w-48 h-12 p-2 cursor-pointer text-[#6f726c] bg-zinc-200 hover:bg-zinc-300"
                on:click|preventDefault={handleExportAll}
            >
                <i class={exportIcon} />
                <p class="pt-1">Export All</p>
            </div>
        </ul>
    </div>
{/if}

{#if isExportingCsvFile}
    <LoadingModal titleText="Exporting CSV File..." />
{/if}
